import { render, staticRenderFns } from "./LogoIcon.vue?vue&type=template&id=d20798d4&scoped=true&lang=pug"
import script from "./LogoIcon.vue?vue&type=script&lang=js"
export * from "./LogoIcon.vue?vue&type=script&lang=js"
import style0 from "./LogoIcon.vue?vue&type=style&index=0&id=d20798d4&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20798d4",
  null
  
)

export default component.exports